import type React from 'react';

export interface NavLeaf {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
}

export function findNavItemByHref(
  navigation: any[],
  pathname: string,
): NavLeaf | null {
  for (const item of navigation) {
    if (item.href && item.href === pathname) {
      return { name: item.name, href: item.href, icon: item.icon };
    }
    if (Array.isArray(item.submenu)) {
      for (const sub of item.submenu) {
        if (sub.href === pathname) {
          return { name: sub.name, href: sub.href, icon: sub.icon };
        }
      }
    }
  }
  return null;
}
